import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';
import Code from '../Code';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoParallelImport extends Component {

    render() {
        const { parallel_import: items } = this.props;
        const summary = getTitleSummary(items)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Параллельный импорт'],
                    rows: summary
                }}
                expanded={(items.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Код',
                        'Товарные знаки, для которых разрешен параллельный импорт',
                        'Исключения',
                        'Нормативный документ'
                    ],
                    rows: items.map(({ to_date = null, code = '', name='', exception_dsc = '',  order, order_date, orders_info }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        <Code code={code} />,
                        name,
                        exception_dsc,
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}







// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoParallelImport.js